import { Star, MessageSquareQuote } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TestimonialsSection = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 2,
      rating: 5,
      content: t('simonsMarketing.testimonials.items.linda.content') as string,
      name: t('simonsMarketing.testimonials.items.linda.name') as string,
      role: t('simonsMarketing.testimonials.items.linda.role') as string,
    },
  ];

  return (
    <section id="testimonials" className="py-24 md:py-32 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-widest text-emerald-400 uppercase mb-4">
            {t('simonsMarketing.testimonials.badge')}
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
            {t('simonsMarketing.testimonials.title_start')}{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-teal-300 bg-clip-text text-transparent">
              {t('simonsMarketing.testimonials.title_highlight')}
            </span>
          </h2>
        </div>

        <div className="grid gap-8 max-w-xl mx-auto">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="relative bg-gray-900 rounded-2xl p-8 border border-gray-800 hover:border-emerald-500/30 transition-colors duration-500"
            >
              <MessageSquareQuote className="w-10 h-10 text-emerald-500/20 mb-6" />

              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-emerald-400 text-emerald-400"
                  />
                ))}
              </div>

              <p className="text-gray-400 leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-3 pt-6 border-t border-gray-800">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center text-white font-bold text-sm">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">
                    {testimonial.name}
                  </p>
                  <p className="text-gray-500 text-xs">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
